"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageCodeName = exports.LanguageCode = void 0;
var LanguageCode;
(function (LanguageCode) {
    LanguageCode["ar_idn"] = "ar-idn";
    LanguageCode["de"] = "de";
    LanguageCode["en"] = "en";
    LanguageCode["nl"] = "nl";
    LanguageCode["zh"] = "zh";
    LanguageCode["fr"] = "fr";
    LanguageCode["es"] = "es";
})(LanguageCode = exports.LanguageCode || (exports.LanguageCode = {}));
exports.LanguageCodeName = 'LanguageCode';
//# sourceMappingURL=language-code.js.map